import {
  faCreditCardFront,
  faMoneyBill1Wave,
  faSquareArrowUpRight
} from '@fortawesome/pro-light-svg-icons'

export const SURVEY_FIELD_TYPES = {
  SMALL_TEXT: 'small-text',
  LARGE_TEXT: 'large-text',
  DROPDOWN: 'dropdown',
  CHECKBOX: 'checkbox',
  RADIO: 'radio'
}

export const LAD_SURVEY_IDS = {
  BRANDS_YOU_LOVE: 'lad_brands_you_love',
  THIRD_PARTY_TOOLS: 'lad_third_party_tools',
  EARN_OPTIONS: 'lad_earn_options'
}

export const SURVEY_DESC_LENGTH = 140

export const EARN_OPTIONS_SURVEY_ICONS = {
  co_branded_credit_card: faCreditCardFront,
  affiliate_program: faSquareArrowUpRight,
  purchase_points: faMoneyBill1Wave
}
